import { Trans, useTranslation } from 'react-i18next';

import { Button } from '@/components/generic';
import { ButtonVariant } from '@/components/generic/Button/button-config';
import { ModalLayout } from '@/components/layouts';
import { ConfirmationModalType } from '@/types';

export const ConfirmationModal = ({
  isOpen,
  onClose,
  onConfirm,
  message = '',
  isDisabled = false,
  showFullMessage = false
}: ConfirmationModalType) => {
  const [t] = useTranslation('common');

  return (
    <ModalLayout isOpen={isOpen} onClose={onClose}>
      <div className='inline-flex size-full flex-col items-center justify-center gap-y-6'>
        <div className='flex w-full flex-col items-center break-words'>
          <div
            className={`w-full max-w-xl px-4 text-center ${showFullMessage ? 'whitespace-pre-line break-words' : 'line-clamp-3 break-all'}`}>
            <Trans i18nKey={t(message)} />
          </div>
          <div className='flex max-w-full gap-8 overflow-hidden px-4 text-center'>
            <Button variant={ButtonVariant.SECONDARY} handleOnClick={onClose} className='my-6 w-32'>
              {t('cancel')}
            </Button>
            <Button
              disabled={isDisabled}
              variant={ButtonVariant.PRIMARY}
              handleOnClick={onConfirm}
              className='my-6 w-32'>
              {t('confirm')}
            </Button>
          </div>
        </div>
      </div>
    </ModalLayout>
  );
};
